import axios from 'axios';
import { CURRENT_API_URL } from "../../../../Utils/Constants";
import notify from '../../../../Notifications/ToastifyActions';


function GetUserProfileDataService(token) {

    return axios.post(`${CURRENT_API_URL}/account/getUserProfileData`, {
    }, 
    {
        headers: {
                    'Authorization': token,
            }
    }).then((res) => {
        return (res.data);
    }).catch(() => {
        notify.NotifyError("Error while fetching user profile data, please try again.");
        return false;
    })
}

export default GetUserProfileDataService;